module.exports = __webpack_public_path__ + "static/media/logo-white.bc2a101e.png";